import React, {useEffect, useRef, useState} from 'react';
import {
    Container,
    FormControl,
    Grid,
    styled,
    TextField,
    Typography
} from '@mui/material';
import {Link, useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {
    MainTitle,
} from './styles';
import Button from '@mui/material/Button';
import {TextareaAutosize as BaseTextareaAutosize} from '@mui/base/TextareaAutosize';
import client, {API_HOST, UI_HOST, userSession} from "../../services/auth/ApiService/client";
import QRCodeStyling, {
    DotType,
    Options
} from 'qr-code-styling';
import {setupImageHeightWidthByContainer} from "../../utils/billing";
import CardContent from "@mui/material/CardContent";
import FilterableTable, { DataRow } from "../../components/FilteredTable";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {IAnketa, ITarriff, ITree} from "../ChangePage/ChangePage";
import axios from "axios";
import {setLoginOpen} from "../../store/appSlice";
import AlertSuccess from "../../components/AlertSuccess";
import { formatNumber } from '../../utils/numbers';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};
const Textarea = styled(BaseTextareaAutosize)(
    ({ theme }) => `
    box-sizing: border-box;
    width: 100%;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: rgba(0, 0, 0, 0.87);
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};

    &:hover {
      border-color: ${blue[400]};
    }

    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }

    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
export interface IService {
    title: string,
    description: string,
    isDefault: boolean,
    type: string,
    price: number,
}
export const initialState: IService[] = []

export interface UserDataSumm {
    cost: number;
    income: number;
}

const BuhPage = () => {
    const [services, setServices] = React.useState<IService[]>(initialState)
    const [valueTab, setValueTab] = React.useState(0);
    const [incoeData, setIncoeData] = React.useState<DataRow[]>([]);
    const [userDataSumm, setUserDataSumm] = React.useState<UserDataSumm>({
        cost: 0,
        income: 0,
    });
    const [openAlert, setOpenAlert] = useState(false);

    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        setValueTab(newValue);
    };

    const handlePriceChange = (index: number, newPrice: number) => {
        setServices((prev) =>
            prev.map((s, i) => (i === index ? {...s, price: newPrice} : s))
        )
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        try {
            await client.post(`${API_HOST}/services`, services)
            setOpenAlert(true)
        } catch (error) {
            console.error('Login error', error)
            // Handle errors (e.g., show error message)
        }
    };

    useEffect(() => {
        const loadData = () => {
            client
                .get('/ankets')
                .then((response) => {
                    const { data }: { data: IAnketa[] } = response;
                    const result = data.map((anketa) => {
                        return {
                            id: anketa.id,
                            isSolder: anketa.isSolder,
                            name: anketa.name,
                            date: anketa.orders[0]?.createdAt,
                            payed: anketa.orders[0].status === 'PAYED',
                            income: anketa.AnketaService?.reduce((acc, service) => {
                                return acc + (service.service.type === 'INCOME' ? service.price : 0)
                            }, 0),
                            cost: anketa.AnketaService?.reduce((acc, service) => acc + (service.service.type === 'COST' ? service.price : 0), 0),
                        } as DataRow;
                    });
                    setIncoeData(result as DataRow[]);
                })
            client
                .get(`/services`)
                .then((response) => {
                    const data = response.data as IService[];
                    console.log(data)
                    setServices(data)
                })
                .catch((error) => {
                    console.log('error')
                    console.log(error)
                })
            client
                .get(`/services/user`)
                .then((response) => {
                    const data = response.data as UserDataSumm;
                    console.log(data)
                    setUserDataSumm(data);
                })
                .catch((error) => {
                    console.log('error')
                    console.log(error)
                })
        }
        loadData()
    }, []);

  return (
      <>
      <Container style={{marginTop: '120px', paddingLeft: '0px', paddingRight: '0px',}}>
          <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={valueTab} onChange={handleChangeTab} aria-label="basic tabs example">
                      <Tab label="Форма доходов / расходов" {...a11yProps(0)} />
                      <Tab label="Таблица расходов / доходов" {...a11yProps(1)} />
                  </Tabs>
              </Box>
              <CardContent>
                  <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                      Расходы и доходы за июнь
                  </Typography>
                  <Typography variant="h5" component="div">
                      Ваши текущие доходы: <b>{formatNumber(userDataSumm.income)}</b> руб.
                  </Typography>
                  <Typography variant="h5" component="div">
                      Ваши текущие расходы: <b>{formatNumber(userDataSumm.cost)}</b> руб.
                  </Typography>
              </CardContent>
              <CustomTabPanel value={valueTab} index={0}>
                 <MainTitle variant="h4" sx={{marginBottom: '40px'}}>Расходы / Доходы компании</MainTitle>

                    <Grid
                        component="form"
                        noValidate
                        autoComplete="off"
                        sx={{marginLeft: 'auto', marginRight: 'auto'}}
                    >
                        <>
                            {services?.length > 0 && services?.map((service, index) => {
                                return service.isDefault && service.type === 'INCOME' && <FormControl key={index} fullWidth sx={{m: 1}}>
                                    <TextField
                                        inputProps={{maxLength: 23}}
                                        type={'number'}
                                        onChange={(e) => handlePriceChange(index, parseFloat(e.target.value) || 0)}
                                        id="outlined-basic2"
                                        label={service.title}
                                        value={service.price}
                                        variant="outlined"
                                    />
                                </FormControl>
                            })}

                            <h4>Дополнительные Доходы</h4>
                            {services?.length > 0 && services?.map((service, key) => {
                                return !service.isDefault && service.type === 'INCOME' && <FormControl fullWidth sx={{m: 1}} key={`${key}-bio`}>
                                    <TextField value={service.price} type={"number"} onChange={
                                        (e) => setServices(
                                            services?.map((b, k) => {
                                                if (k === key) {
                                                    return {
                                                        ...b,
                                                        price: Number(e.target.value),
                                                    }
                                                }
                                                return b;
                                            }))
                                    } id="outlined-basic2" label="Сумма" variant="outlined"/>
                                    <Textarea aria-label="minimum height" placeholder="Описание" minRows={5}
                                              sx={{mb: 2}}
                                              value={service.title} onChange={
                                        (e) => setServices(
                                            services?.map((b, k) => {
                                                if (k === key) {
                                                    console.log(b)
                                                    return {
                                                        ...b,
                                                        title: e.target.value,
                                                    }
                                                }
                                                return b;
                                            }))
                                    }/>
                                    <Button
                                        variant="contained"
                                        component="label"
                                        onClick={() => {
                                            const newBio = [...services];
                                            newBio.splice(key, 1)
                                            setServices(newBio)
                                        }}
                                    >
                                        Убрать
                                    </Button>
                                </FormControl>
                            })}
                            <Button
                                variant="contained"
                                component="label"
                                sx={{mb:2}}
                                onClick={() => {
                                    const newBio = [...services];
                                    newBio.push({
                                        title: '',
                                        description: '',
                                        price: 0,
                                        type: 'INCOME',
                                        isDefault: false,
                                    })
                                    console.log(newBio)
                                    setServices(newBio)
                                }}
                            >
                                Добавить
                            </Button>

                            <hr/>

                            <h4>Дополнительные Расходы</h4>
                            {services?.length > 0 && services?.map((service, key) => {
                                return !service.isDefault && service.type === 'COST' && <FormControl fullWidth sx={{m: 1}} key={`${key}-bio`}>
                                    <TextField value={service.price} type={"number"} onChange={
                                        (e) => setServices(
                                            services?.map((b, k) => {
                                                if (k === key) {
                                                    return {
                                                        ...b,
                                                        price: Number(e.target.value),
                                                    }
                                                }
                                                return b;
                                            }))
                                    } id="outlined-basic2" label="Сумма" variant="outlined"/>
                                    <Textarea aria-label="minimum height" placeholder="Описание" minRows={5}
                                              sx={{mb: 2}}
                                              value={service.title} onChange={
                                        (e) => setServices(
                                            services?.map((b, k) => {
                                                if (k === key) {
                                                    return {
                                                        ...b,
                                                        title: e.target.value,
                                                    }
                                                }
                                                return b;
                                            }))
                                    }/>
                                    <Button
                                        variant="contained"
                                        component="label"
                                        onClick={() => {
                                            const newBio = [...services];
                                            newBio.splice(key, 1)
                                            setServices(newBio)
                                        }}
                                    >
                                        Убрать
                                    </Button>
                                </FormControl>
                            })}
                            <Button
                                variant="contained"
                                component="label"
                                sx={{mb:2}}
                                onClick={() => {
                                    const newBio = [...services];
                                    newBio.push({
                                        title: '',
                                        description: '',
                                        price: 0,
                                        type: 'COST',
                                        isDefault: false,
                                    })
                                    setServices(newBio)
                                }}
                            >
                                Добавить
                            </Button>
                        </>
                    </Grid>
                  <Button
                      variant="contained"
                      component="label"
                      sx={{mt:4}}
                      onClick={(e) => handleSubmit(e)}
                  >
                      Сохранить изменения
                  </Button>
              </CustomTabPanel>
              <CustomTabPanel value={valueTab} index={1}>
                  <FilterableTable incomeData={incoeData as any} />
              </CustomTabPanel>
          </Box>
      </Container>
          <AlertSuccess open={openAlert} setOpen={setOpenAlert} message="Изменения сохранены!" />
      </>
  );
}

export default BuhPage;